<template>
	<div>
		  <!-- 免费评估-->
    <van-dialog v-model="mfpgDlgShow" :title="dlgTitle" :show-confirm-button="false">
      <van-icon name="cross" class="dlgClose" size="20" @click="clearModel()" />
      <van-cell-group style="margin-top:0.2rem">
        <!--<van-field label="设备售价" placeholder=""  label-width="70" disabled ></van-field>-->
        <van-field
          readonly
          clickable
          label="设备类型"
          :value="pickerVal"
          placeholder="请选择类型"
          @click="showPicker = true"
          label-width="70"
          right-icon="arrow-down"
        />
        <van-field
          readonly
          clickable
          label="设备品牌"
          placeholder="请选择品牌"
          :value="pickerValOne"
          @click="showPickerOne = true"
          label-width="70"
          right-icon="arrow-down"
        />
         <van-field
         	v-model= "gModel.time"
         	readonly
          clickable
         	label="出厂日期"
          placeholder="选择时间" 
          @click="endTimePop = true"
          label-width="70"
          right-icon="notes-o"
         />
         <van-field
          readonly
          clickable
          label="所在省份"
          :value="privince.text"
          placeholder="请选择省份"
          @click="privince.isShow = true"
          label-width="70"
          right-icon="arrow-down"
        />
         <!--<van-field
          readonly
          clickable
          label="所在城市"
          :value="city.text"
          placeholder="请选择城市"
          @click="city.isShow = true"
          label-width="70"
          right-icon="arrow-down"
        />-->
         <van-field  
         	readonly
          v-model="gModel.user"
          clickable label="联系人"  
          label-width="70">   
          
         </van-field>
         <van-radio-group v-model="radio" style="">
          <van-radio name="1" >是</van-radio>
          <van-radio name="0" >否</van-radio>
        </van-radio-group>
      
        <van-field v-model="gModel.phone"  clearable label="电话" placeholder="请输入您的手机号" label-width="70" style="top:-20px" />
         <van-field
         	v-model ="gModel.message"
          style="top:-20px"
          rows="2"
          autosize
          label="留言"
          type="textarea"
          placeholder="请输入留言内容"
          label-width="70"
        />
      </van-cell-group>
      <van-button type="danger" block  @click="setInfomation">提交信息</van-button>
    </van-dialog>
    <!--选择时间 -->
     <van-popup v-model="endTimePop" label="出厂日期" position="bottom" :overlay="true">
          <van-datetime-picker
          	:min-date ="minDate"
            :max-date="currentDate"
            type="date"
            @cancel="endTimePop = false"
            @confirm="endTimePop = false"
            @change="endTimeChange"
          />
      </van-popup>
    <!--设备类型 -->
    <van-popup v-model="showPicker" position="bottom">
      <van-picker
        show-toolbar
        :columns="columns"
        @cancel="showPicker = false"
        @confirm="onConfirm"/>
    </van-popup>
   <!--设备品牌 -->
   <van-popup v-model="showPickerOne" position="bottom">
      <van-picker
        show-toolbar
        :columns="columnsOne"
        @cancel="showPickerOne = false"
        @confirm="onConfirmOne"/>
    </van-popup>
    <!--省份 -->
   <van-popup v-model="privince.isShow" position="bottom">
      <van-picker
        show-toolbar
        :columns="columnsPrivince"
        @confirm="onConfirmPrivince"
        @cancel="privince.isShow = false"/>
   </van-popup>
   <!--城市 -->
   <van-popup v-model="city.isShow" position="bottom">
      <van-picker
        show-toolbar
        :columns="columnsCity"
        @confirm="onConfirmCity"
        @cancel="city.isShow = false"/>
    </van-popup>
   
	</div>
</template>

<script>
	
import EquipmentService from "@/services/EquipmentService";
import validate from "@/utils/common";
export default {
  name: "equipment",
  components: {
  },  
  props:{
			mfpgDlgShow: {
				type: Boolean,
				default:false
			},
			//标题
			dlgTitle: {
				type: String,
				default: ''
			},
			dlgPath: {
				type: String,
				default: ''
			}
  },//["mfpgDlgShow","dlgTitle","dlgPath"],
  data() {
    return {
      openId: "",
      pService: null,
//     dlgTitle:'免费评估',
//    dlgPath:'',
      //mfpgDlgShow:true,
      showPicker: false,
      showPickerOne:false,
      pickerVal: "",
      pickerValue: "",
      pickerValOne: "",
      pickerValueOne: "",
      columns: [],
      columnsOne:[],
      columnsPrivince:[],
      columnsCity:[],
      privince:{text:'',value:'',isShow:false},
      city:{text:'',value:'',isShow:false},
      endTimePop: false,
      minDate:new Date(2005, 0, 1),
      currentDate: new Date(),
      radio: '1',
      gModel:{
      	user:'',
      	time:'',
      	phone:'',
      	message:''
      }
    }
  },
   created() {
  	if(localStorage.getItem('openId') !=="null"){
  		this.openId = localStorage.getItem('openId');
  	}
    this.pService = new EquipmentService();
    this.getPrivince();
    this.equipmentType();
    this.getPinpaiList();
  },
  mounted() {
  	
  },
  methods: {
  			/*
  	 * 清除实体
  	 */
  	clearModel(){
  		this.$emit('fun',false);
  		 this.gModel = {
  		 	time:'',
      	phone:'',
      	message:''
      };
      this.pickerVal = '';
      this.pickerValue = '';
      this.pickerValOne = '';
      this.pickerValueOne = '';
      this.radio ='1';
      this.privince ={text:'',value:'',isShow:false};
      this.city ={text:'',value:'',isShow:false};
  	},
	  /*
     * 获取时间
     */
     endTimeChange(e) {
        let endTimeArr = e.getValues();//["2019", "03", "22", "17", "28"]
        this.gModel.time = `${endTimeArr[0]}-${endTimeArr[1]}-${endTimeArr[2]} `
     },
     equipmentType() {
      this.pService.equipmentType({ OpenID: this.openId }, res => {  
        res.forEach((v, i) => {
        	//this.columns.push(v);   
        	if(v.TypeCode){
              this.columns.push({text: v.TypeName,value:(v.TypeCode ? v.TypeCode :0)})                     		
        	}
        });

      });
    },
    getPinpaiList(){
				  this.pService.deviceList({OpenID:this.openId,ParameterGenreCode:'SBPPP'},res =>{
				 	   res.forEach((v,i) =>{
				 	   	if(v.value){
				 	   		this.columnsOne.push({text: v.text,value:(v.value ? v.value :0)})
				 	   	}				 	   	  
				 	  })
      });
   },
    getPrivince(){
				 this.pService.provinceList({OpenID:this.openId},res =>{
				 	   res.forEach((v,i) =>{
				 	   	   if(v.Pro_Code){
				 	   	   	 this.columnsPrivince.push({text: v.Pro_Name,value:(v.Pro_Code ? v.Pro_Code :0)})
				 	   	   }				 	   	   
				 	   })
				 	   //console.log(this.columnsPrivince)
				 })
			},
		 getCity(pCode){
				 this.pService.cityList({OpenID:this.openId,Pro_Code:pCode},res =>{
				 	   res.forEach((v,i) =>{
				 	   	   this.columnsCity.push({text: v.City_Name,value:(v.City_Code ? v.City_Code :0)})
				 	   })
				 })
		},
				/*
		 * 发布信息
		 */
		setInfomation(){
			if(!this.pickerValue){
  		  this.$toast({message: "请选择设备类型"})
  			return;
  		}
			if(!this.pickerValueOne){
  		  this.$toast({message: "请选择设备品牌"})
  			return;
  		}
			if(!this.gModel.time){
  		  this.$toast({message: "请选择出厂日期"})
  			return;
  		}
  		if(!this.privince.value){
  		  this.$toast({message: "请选择省份"})
  			return;
  		}
//	  if(!this.city.value){
//		  this.$toast({message: "请选择城市"})
//			return;
//		}
  		if(!this.gModel.phone){
  		  this.$toast({message: "请输入联系电话"})
  			return;
  		}
  		if(!validate.IsPhone(this.gModel.phone)){
  			this.$toast({message: "手机号码格式有误"})
  			return;
  		}

  		this.pService.setInfomation(this.dlgPath,{
  			OpenID:this.openId,
  			TypeCode:this.pickerValue,
  			DeviceBrandCode:this.pickerValueOne,
  			FactoryDate:this.gModel.time,
  			IsAllowTransfer:this.radio,
  			ProvinceCode:this.privince.value,
  			CityCode:this.city.value,  			
  			Tell:this.gModel.phone,
  			Remark:this.gModel.message
  		},res =>{
  			 //console.log(res);
  			 res.success ? this.$toast.success("信息提交成功") : this.$toast.fail(res.result);  	
  			 if(res.success){
  			 	 this.clearModel();
  			 	 //this.$emit('fun',false)
  			     //this.mfpgDlgShow = false;  			 	 
  			 }

  		})
		},
    dialogInit(path,title){
    	this.dlgTitle = title;
    	this.dlgPath = path;
    	this.getPrivince();
    },
    onConfirm(val) {
      this.pickerVal = val.text;
      this.pickerValue = val.value;
      this.showPicker = false;
    },
    onConfirmOne(val) {
      this.pickerValOne = val.text;
       this.pickerValueOne = val.value;
      this.showPickerOne= false;
    },
    onConfirmPrivince(val){
    	this.privince.text = val.text;
    	this.privince.value = val.value;
        this.privince.isShow= false;
      
       //调用城市
       this.getCity(this.privince.value);
    },
    onConfirmCity(val){
    	this.city.text = val.text;
    	this.city.value = val.value;
        this.city.isShow= false;
    }

  }
 }
</script>

<style>
</style>


// WEBPACK FOOTER //
// src/components/equipment/SetDevice.vue